export default __webpack_public_path__ + "static/media/professional.14e91e04.png";